import asyncActionType from "../../utils/asyncActionType";

export const FETCH_PENDING_INVENTORY_LIST = asyncActionType("FETCH_PENDING_INVENTORY_LIST");
export const FETCH_PENDING_INVENTORY_DETAIL = asyncActionType("FETCH_PENDING_INVENTORY_DETAIL");
